export default [
  {
    id: 1,
    name: "Source Code.zip",
    size: "1.5M",
    type: "zip",
    updatedAt: "2019年02月03日",
  },
  {
    id: 2,
    name: "2017级网络工程成绩表.xls",
    size: "378k",
    type: "excel",
    updatedAt: "2018年03月04日",
  },
  {
    id: 3,
    name: "屏幕截图-2010-08-01.png",
    size: "4.8M",
    type: "image",
    updatedAt: "2012年01月24日",
  },
  {
    id: 4,
    name: "JavaScript The Definitive Guide",
    size: "4.2M",
    type: "pdf",
    updatedAt: "昨天 下午18:30",
  },
  {
    id: 5,
    name: "ABC 技术峰会演讲稿.ppt",
    size: "1.8M",
    type: "ppt",
    updatedAt: "今天 上午08:30",
  },
  {
    id: 6,
    name: "2020毕业论文.docx",
    size: "2.4M",
    type: "word",
    updatedAt: "2020年02月29日",
  },
  {
    id: 7,
    name: "南京紫峰大厦.jpg",
    size: "4.2M",
    type: "image",
    updatedAt: "2019年12月13日",
  },
];
